// extracted by mini-css-extract-plugin
module.exports = {"inner":"header-module--inner--CtgRk","outer":"header-module--outer--3q8Ka"};